<template>
  <div class="lookContainer">
    <div class="lookContainer_nav">
      <button class="backUp" @click="goBack">返回上级</button>
      <button class="backUp" @click="downLoadFn">证据下载</button>
    </div>
    <div class="lookContent" v-if="fileArray.length && seeData">
      <div class="left_certificate">
        <see :data="seeData" v-if="seeData" class="certificate"></see>
      </div>
      <div class="right_certificate" v-if="seeFormat === 'pdf'">
        <!-- <pdf></pdf>  -->
        <div class="cerTitle">
          <span
            >{{ pdfObject.currentIndex }} / {{ pdfObject.totalNumber }}</span
          >
        </div>
        <canvas
          id="newCanvas"
          ref="newCanvas"
          style="width: 100%; display: block; margin: 0 auto; margin-top: 0px"
        ></canvas>
        <img
          src="../../../assets/images/lookCertificate/left.png"
          class="pdf_left"
          @click="changePage(true)"
        />
        <img
          src="../../../assets/images/lookCertificate/right.png"
          class="pdf_right"
          @click="changePage(false)"
        />
      </div>
      <div class="right_certificate" v-if="seeFormat === 'image'">
        <el-image
          style="width: 100%;height: 100%;"
          :src="fileInfo.filePath"
          fit="contain"
          :preview-src-list="[fileInfo.filePath]"
          ></el-image>
      </div>
    </div>
    <div v-if="isNoData" class="lookContainer_error">
      <img src="../../../assets/images/lookCertificate/nosave_icon.png" />
    </div>
    <!-- <div class="modal-box" v-show="showMsgModal">
		<div class="context" @click="closeModal"></div>
		<div class="modal">
			<div class="modal-title">消息提示<span class="modal-close" @click="closeModal"><img src="../../../assets/images/lookCertificate/x.png"></span></div>
			<div class="modal-content" ></div>
		</div>
	</div> -->
  </div>
</template>
<script>
import Breadcrumb from "../../../components/common/Breadcrumb.vue";
// import PDFJS from "pdfjs-dist/webpack";
import browser from "@lib/getBrowser.js";
import BaseApi from "@lib/baseApi.js";
import Util from "@lib/util.js";
import see from "@common/see.vue";

export default {
  data() {
    return {
      seeData: null,
      seefileUrl: "",
      pdfObject: {
        zoom: false,
        scale: 0.59,
        newScale: 1.4,
        currentIndex: 1,
        totalNumber: 1,
        path: "",
        loading: false,
      },
      fileArray: [],
      showMsgModal: false,
      isNoData: false,

      imageFormat: ["png", "jpg", "jpeg"],
      seeFormat: "pdf", // pdf, image

      fileInfo: {},
    };
  },
  components: {
    Breadcrumb,
    see,
  },
  mounted() {
    this.getFiled();

    $(window).resize(() =>
      // 绑定到窗口的这个事件中
      {
        this.judgeMoreShow();
      }
    );
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    closeModal() {
      this.showMsgModal = false;
    },
    getCrea(fileId, notaryApplyId) {
      this.seeData = null;
      BaseApi.createRpcToken("/file/cert", {
        fileId: fileId || 1,
        notaryApplyId: notaryApplyId == "undefined" ? "" : notaryApplyId,
      }).then(
        (data) => {
          this.seeData = data.datas.cert;
          this.$nextTick(() => {
            this.pdfRender();
          });
        },
        () => {}
      );
    },
    getFiled() {
      BaseApi.createRpcToken("/file/list", {
        id: this.$route.query.id || "",
        fileType: "all",
      })
        .then(
          (data) => {
            this.fileArray = data.datas.list;
            if (data.datas.list) {
              const fileInfo = this.fileArray.filter(
                (item) => item.id == this.$route.query.fileId
              )[0];
              if (!fileInfo) {
                this.isNoData = false;
                return;
              }
              this.fileInfo = fileInfo;
              if (this.imageFormat.includes(fileInfo.fileFormat)) {
                // 图片
                this.seeFormat = "image";
                this.seefileUrl = fileInfo.filePath;
                this.$nextTick(() => {
                  this.getCrea(
                    this.$route.query.fileId,
                    this.$route.query.notaryApplyId
                  );
                });
                console.log("图片");
              } else {
                this.seefileUrl = fileInfo.filePath;
                this.activeChange(
                  "",
                  this.fileArray.filter(
                    (item) => item.id == this.$route.query.fileId
                  )[0]
                );
                this.judgeMoreShow();
              }
            }
            if (this.fileArray.length) {
              this.isNoData = false;
            } else {
              this.isNoData = true;
            }
          },
          () => {}
        )
        .catch(function (e) {
          errorLog(e);
        });
    },
    judgeMoreShow() {
      let interValFlag = setInterval(() => {
        if ($(".el-tabs__nav-wrap").width()) {
          clearInterval(interValFlag);
          if ($(".el-tabs__nav-next")[0]) {
            this.showMoreBtn = true;
          } else {
            this.showMoreBtn = false;
          }
        }
      }, 10);
    },
    activeChange(node, item) {
      this.currentItem = (node && node.$attrs.item) || item;
      this.activeName = this.currentItem.id;
      this.$nextTick(() => {
        this.getCrea(this.$route.query.fileId, this.$route.query.notaryApplyId);
      });
    },
    // pdf切换页码
    changePage(is) {
      if (this.clickIndex) {
        if (is) {
          if (this.pdfObject.currentIndex <= 1) {
            this.showMsgModal = true;
            return false;
          } else {
            this.pdfObject.currentIndex--;
          }
        } else {
          if (this.pdfObject.currentIndex >= this.pdfObject.totalNumber) {
            this.showMsgModal = true;
            return false;
          } else {
            this.pdfObject.currentIndex++;
          }
        }
        this.clickIndex = false;
        // console.log("Start/render:", this.clickIndex)
        this.pdfRender();
      }
    },
    pdfRender() {
      var _this = this;
      var canvas = _this.$refs.newCanvas;
      var scale = 1; //缩放倍数，1表示原始大小
      var canvasContainerWidth = 430;
      var url = this.seefileUrl || "http://localhost:3200/离线验证指引.pdf";
      // var url = '../../assets/images/1.pdf';
      PDFJS.getDocument(url).then(function getPdfHelloWorld(pdf) {
        _this.pdfObject.totalNumber = pdf.numPages;
        pdf
          .getPage(_this.pdfObject.currentIndex)
          .then(function getPageHelloWorld(page) {
            /* Canvas Start */
            var scale = _this.pdfObject.scale;
            var viewport = page.getViewport(scale);
            viewport = page.getViewport(canvasContainerWidth / viewport.width);
            var context = canvas.getContext("2d");
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            var renderContext = {
              canvasContext: context,
              viewport: viewport,
            };
            /* Canvas End */

            /* new Canvas Start */
            // var newScale = _this.pdfObject.newScale;
            // var newViewport = page.getViewport(newScale);
            // var newContext = newCanvas.getContext("2d");
            // newCanvas.width = newViewport.width;
            // newCanvas.height = newViewport.height;
            // var newRenderContext = {
            //   canvasContext: newContext,
            //   viewport: newViewport
            // };
            /* new Canvas End */
            page.render(renderContext);
            // page.render(newRenderContext);
            setTimeout(function () {
              _this.clickIndex = true;
              _this.pdfObject.loading = false;
              // console.log("End/render:", _this.clickIndex);
            }, 500);
          });
      });
    },
    downLoadFn() {
      //签约下载
      BaseApi.createRpcToken("/file/downloadContractFileZip", {
        fileId: this.$route.query.fileId,
      })
        .then((data) => {
          if (data.datas.zipUrl) {
            try {
              var elemIF = document.createElement("iframe");
              elemIF.src = data.datas.zipUrl;
              elemIF.style.display = "none";
              elemIF.setAttribute("id", "startDown");
              if (document.getElementById("startDown")) {
                document.body.removeChild(document.getElementById("startDown"));
              }
              document.body.appendChild(elemIF);
            } catch (e) {}
            // window.open(data.datas.zipUrl);
          } else {
            this.$message.error("下载失败");
          }
        })
        .catch(function (e) {
          errorLog(e);
        });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scope>
.lookContainer {
  width: 1060px;
  height: 100%;
  .lookContainer_nav {
    width: 320px;
    margin: 0 auto;
    margin-top: 20px;
  }
  .backUp {
    width: 100px;
    height: 34px;
    border-radius: 3px;
    border: 1px solid #ccc;
    margin: 0 auto;
    margin-bottom: 20px;
    display: inline-block;
    color: #323232;
    cursor: pointer;
    margin-right: 20px;
  }
  .backUp:nth-child(2) {
    margin-right: 0px;
  }

  .backUp:hover {
    border-color: #d81212;
    color: #d81212;
  }

  .lookContent {
    display: flex;
  }

  .lookContainer_error {
    width: 300px;
    height: 100px;
    text-align: center;
    line-height: 100px;
    margin: 0 auto;

    img {
      width: 100px;
      margin-top: 30px;
    }
  }

  .left_certificate {
    width: 440px;
  }

  .right_certificate {
    width: 500px;
    height: 690px;
    border: 1px solid #ccc;
    margin-left: 60px;
    overflow-y: scroll;
    position: relative;

    .pdf_left {
      position: absolute;
      left: 0px;
      top: 50%;
      cursor: pointer;
    }

    .pdf_right {
      position: absolute;
      right: 0px;
      top: 50%;
      cursor: pointer;
    }

    .cerTitle {
      width: 100%;
      line-height: 45px;
      text-align: center;
      font-size: 16px;
      height: 45px;
      border-bottom: solid 1px #b4bec3;
    }
  }
}

.modal-box,
.context {
  height: 100%;
  width: 100%;
  position: fixed;
  left: 0;
  z-index: 99999;
  top: 0;
}

// .context{
// 	background-color: rgba(0,0,0,0.4);
// }
.modal {
  position: absolute;
  min-height: 155px;
  width: 340px;
  left: 50%;
  top: 40%;
  z-index: 99999999;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 8px;
  font-size: 14px;
}

.modal-title {
  height: 40px;
  line-height: 40px;
  background-color: #d03346;
  color: #fff;
  padding-top: 1px;
  margin-top: -1px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  text-align: center;
  position: relative;
}

.modal-close {
  position: absolute;
  right: 12px;
  top: 13px;
  width: 12px;
  height: 12px;
  display: block;
  text-align: center;
  cursor: pointer;
}

.modal-close img {
  width: 100%;
}

.modal-content {
  min-height: 95px;
  padding: 40px 18px;
  text-align: center;
}

/*transition Start*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
</style>
